export const strapi_end_point ="https://api.gurucool.xyz";
if (typeof window !== 'undefined') {
    var base_url = location.protocol + '//' + location.host; // (or whatever)
  } else {
    var base_url = "http://localhost:3000/";
  }
export const padhaai_url = base_url;